define('customerInternalCommentsView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'customerInternalCommentsEditView',
  'commentsTagsView',
  'customerInternalCommentsListView',
  'template!customerInternalCommentsView',
  'entities/customers/customers_comments'
], function(
  App,
  Module,
  Backbone,
  Marionette,
  _,  
  Settings,
  EditView,
  TagsView,
  ListView,
  Tpl
) {
  'use strict';
  
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'customer-comments-view',
    opened: false,

    ui: {
      openButton: '.open-button',
      closeButton: '.close-button',
      counter: '.counter',
      AddCommentButton: '.add-button'
    },

    events: {
      'click @ui.openButton':'onOpen',
      'click @ui.closeButton':'onClose',
      'click @ui.AddCommentButton': 'onAdd',
      'click @ui.tag': 'onTagClick'
    },

    regions: {
      tagsRegion: '.tags-region',
      listRegion: '.list-region'
    },

    onShow: function() {
      if(Settings.configValue('advancedMode') === true) {
        this.tagsView = new TagsView({showAll: true});
        this.getRegion('tagsRegion').show(this.tagsView);   
        this.tagsView.setSelected('');
      }

      //-------------------
      this.listView = new ListView({       
        secId: this.options.customer.get('secId'),
        tagsView: this.tagsView,
        parentView: this
      });
      this.listView.on('fetched', _.bind(function() {
        this.ui.counter.html(this.listView.collection.length);
      }, this));
      this.getRegion('listRegion').show(this.listView);   
    },

    onRender: function() {
      if(this.opened)
        this.$el.addClass('open');
    },

    onOpen: function() {      
      this.$el.addClass('open');
      this.trigger('open');
    },

    onClose: function(e) {     
      e.stopPropagation();
      this.$el.removeClass('open');
      this.trigger('close');  
    },

    onAdd: function () {
      this.editview = EditView.prototype.open({
        model: new Backbone.Model({comment: ''}),
        title: _.i18n('common.new-comment'),
        onConfirm: _.bind(function (value, tags = []) {
          var currentUserPid = Settings.get('currentUser');
          var comment = new Backbone.Model({
            type: 'order',
            content: value ? value : '',
            externalId: '',
            externalUserId: currentUserPid.externalId ? currentUserPid.externalId : '',
            msgDate: new Date().getTime(),
            title: '',
            user: currentUserPid.secId,
            notSend: true,
            userpid:
            {
              email: currentUserPid.email,
              firstName: currentUserPid.firstName,
              lastName: currentUserPid.lastName,
              logo: currentUserPid.logo
            }
          });

          this.listView.collection.add(comment, { at: 0 });

          //-----------------         
          var model = App.request('customercomments:get-model');
          model.set('comment', comment.get('content'));
          model.set('refUserpid', comment.get('userpid'));
          model.addTag(this.tag);          
          model.unset('content');
          model.unset('modDate');
          model.unset('userpid');

          var tagsIds = [];
          _.each(tags, function (tag) {
            tagsIds.push(tag.get('id'));
          }, this);     

          model.set('tags', tagsIds.join(','));

          model.save(this.options.customer.get('secId')).done(_.bind(function() {
            this.listView.fetch(this.options.customer.get('secId'));
          }, this)).fail(_.bind(function() {
            this.listView.fetch(this.options.customer.get('secId'));
          }, this));
        }, this)
      });
    }
  });
});

